import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { Helmet } from "react-helmet";
import Header from "../body_root/header";
import Footers from "../body_root/footer";
import Navbar from "../body_root/Navbar";
import CountryCodeSelect from "../body_root/CountryCodeSelect";
import { Toast } from "../components_root/ToastContext";
import { Save_phonebook } from "./save_phonebook";
import { MdAdd, MdCall, MdCancel, MdClose, MdSearch } from "react-icons/md";
import Cookies from "js-cookie";
import Lodinging from "../components_root/loading.jsx";
import "./phonebook.css";
import { useNavigate } from "react-router-dom";
export const seo = {
    title: "Free Online Phonebook | Manage Personal Contacts Easily - Viabig",
    description:
        "Create and manage your personal phonebook online for free with Viabig. Add, edit, and organize contacts with categories, mobile numbers, and more. Simple, secure, and easy to use.",
    keywords:
        "free phonebook, online phonebook, manage contacts online, personal phonebook, free contact manager, digital phonebook, viabig phonebook",
    url: "https://viabig.com/phonebook",
    image: "https://viabig.com/assets/logo.png"
};

export default function Phonebook() {
    const { Toastshow } = Toast();
    const [category, setCategory] = useState("");
    const [name, setName] = useState("");
    const [countrycode, setCountryCode] = useState("+91");
    const [mobilenumber, setMobileNumber] = useState("");
    const [phonenumber, setPhoneNumber] = useState("");
    const [reference_number, setReferenceNumber] = useState("");
    const [emailid, setEmailid] = useState("");
    const [website, setWebsite] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [showMore, setShowMore] = useState(false);
    const [addcontact, setAddcontact] = useState(false);
    const [phonebookData, setPhonebookData] = useState([]);
    const [categoryData, setCategoryData] = useState([]);

    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [selectcategory, setSelectcategory] = useState("All");
    const [allPhonebookData, setAllPhonebookData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const postTrades = async () => {
        if (!category) return Toastshow("Please select a category");
        if (!name.trim()) return Toastshow("Please enter a name");
        if (!mobilenumber.trim()) return Toastshow("Please enter mobile number");

        try {
            const result = await Save_phonebook({
                name,
                countrycode,
                category,
                mobilenumber,
                emailid,
                website,
                phonenumber,
                reference_number,
                address,
                city,
                state,
                country
            });

            if (result.success) {
                // Toastshow("Post saved successfully!");
                setShowMore(false);
                fetchPhonebook();
                fetc_CategoryData();
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };

    const handleSearch = (value) => {
        setSearchTerm(value);

        if (!value.trim()) {
            // reset to full list if search is empty
            setPhonebookData(allPhonebookData);
            return;
        }

        const filtered = allPhonebookData.filter((row) => {
            const name = row?.child?.name?.toLowerCase() || "";
            const mobile = row?.child?.mobilenumber?.toLowerCase() || "";
            const phonenumber = row?.phonenumber?.toLowerCase() || "";
            const reference_number = row?.reference_number?.toLowerCase() || "";
            return (
                name.includes(value.toLowerCase()) ||
                mobile.includes(value.toLowerCase()) ||
                phonenumber.includes(value.toLowerCase())
                ||
                reference_number.includes(value.toLowerCase())
            );
        });

        setPhonebookData(filtered);
    };
    const fetchPhonebook = async () => {
        setIsLoading(true);
        try {
            const phonebookQuery = query(
                collection(db, "phonebook"),
                orderBy("date_time", "desc"),
                where("guid", "==", Cookies.get("guid"), limit(100))
            );

            const snapshot = await getDocs(phonebookQuery);
            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });
                    return { uid: docSnap.id, ...docData, child };
                })
            );

            //setAllPhonebookData(docs);   // keep full list
            setPhonebookData(docs);      // also set visible list
            setIsLoading(false);
        } catch (err) {
            console.error("Error fetching phonebook:", err);
        }
        setIsLoading(false);
    };
    useEffect(() => {
        fetchPhonebook();
    }, []);

    const fetc_CategoryData = async () => {
        setIsLoading2(true);
        try {
            const phonebookQuery = query(
                collection(db, "phonebook"),
                where("guid", "==", Cookies.get("guid"))
            );

            const snapshot = await getDocs(phonebookQuery);

            const docs = snapshot.docs.map((docSnap) => docSnap.data().category);

            // Remove duplicates
            const uniqueCategories = [...new Set(docs)];

            setCategoryData(uniqueCategories);
        } catch (err) {
            console.error("Error fetching phonebook:", err);
        }
        setIsLoading2(false);
    };
    useEffect(() => {
        fetc_CategoryData();
    }, []);


    const fetch_by_CategoryData = async (category) => {
        // setIsLoading(true);
        try {
            const phonebookQuery = query(
                collection(db, "phonebook"),
                where("category", "==", category),
                where("guid", "==", Cookies.get("guid"))
            );

            const snapshot = await getDocs(phonebookQuery);

            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });
                    return { uid: docSnap.id, ...docData, child };
                })
            );

            setAllPhonebookData(docs);   // keep full list
            setPhonebookData(docs);      // also set visible list
        } catch (err) {
            console.error("Error fetching phonebook:", err);
        }
        setIsLoading(false);
    };

    // const toggleMoreInfo = (uid) => {
    //     setExpandedRows((prev) => ({ ...prev, [uid]: !prev[uid] }));
    // };
    const PhonebookContact = (uid) => {
        return "phonebook-edit/?id=" + uid; // example path
    };
    return (
        <div>
            <Header />
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size">
                    <div className="post-container">
                        {/* Form to add new phonebook entry */}
                        {addcontact && (
                            <div className="post_updates">
                                <div className="ui-grid-fill">
                                    <div className="ui-items items-back">
                                        <div className="rounded border p-1 m-1">
                                            <label className="text-h2 bold">Category</label>
                                            <input
                                                className="fcap text-h2 border-none bold"
                                                placeholder="Category *"
                                                value={category}
                                                onChange={(e) => setCategory(e.target.value)}
                                            />
                                        </div>
                                        <div className="rounded border p-1 m-1">
                                            <label className="text-h2 bold">Name</label>
                                            <input
                                                className="fcap text-h2 bold border-none"
                                                placeholder="Name *"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                        <div className="rounded border p-1 m-1">
                                            <label className="text-h2 bold">Mobile</label>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <CountryCodeSelect value={countrycode} onChange={setCountryCode} />
                                                <input
                                                    className="text-h2 bold border-none"
                                                    maxLength={12}
                                                    placeholder="Mobile number *"
                                                    value={mobilenumber}
                                                    onChange={(e) => setMobileNumber(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        {showMore && (
                                            <>

                                                <div className="rounded border p-1 m-1">
                                                    <label className="text-h2 bold">Phone</label>
                                                    <div style={{ display: "flex", alignItems: "center" }}>
                                                        <div className="bold text-right" style={{ width: '50px' }}>{countrycode}</div>
                                                        <input
                                                            className="text-h2 bold border-none"
                                                            maxLength={12}
                                                            placeholder="Phone number"
                                                            value={phonenumber}
                                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                                        />
                                                    </div> </div>
                                                <div className="rounded border p-1 m-1">
                                                    <label className="text-h2 bold">Email</label>

                                                    <input
                                                        className="text-h2 bold border-none"
                                                        maxLength={200}
                                                        placeholder="Enter Email"
                                                        value={emailid}
                                                        onChange={(e) => setEmailid(e.target.value)}
                                                    />

                                                </div>
                                                <div className="rounded border p-1 m-1">
                                                    <label className="text-h2 bold">Website</label>

                                                    <input
                                                        className="text-h2 bold border-none"
                                                        maxLength={200}
                                                        placeholder="Enter website"
                                                        value={website}
                                                        onChange={(e) => setWebsite(e.target.value)}
                                                    />

                                                </div>
                                            </>
                                        )}
                                        <div className="rounded border p-1 m-1">
                                            <label className="text-h2 bold">R/F/H/No</label>
                                            <input
                                                className="text-h2 border-none"
                                                maxLength={15}
                                                placeholder="Reference Number"
                                                value={reference_number}
                                                onChange={(e) => setReferenceNumber(e.target.value)}
                                            />
                                        </div>
                                        <div className="rounded border p-1 m-1">
                                            <label className="text-h2 bold">Address</label>
                                            <textarea
                                                className="text-h2 border-none"
                                                maxLength={120}
                                                placeholder="Address"
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                            />
                                        </div>

                                        {showMore && (
                                            <>

                                                <div className="rounded border p-1 m-1">
                                                    <label className="text-h2 bold">City</label>
                                                    <input
                                                        className="text-h2 border-none"
                                                        maxLength={120}
                                                        placeholder="City"
                                                        value={city}
                                                        onChange={(e) => setCity(e.target.value)}
                                                    />
                                                </div>
                                                <div className="rounded border p-1 m-1">
                                                    <label className="text-h2 bold">State</label>
                                                    <input
                                                        className="text-h2 border-none"
                                                        maxLength={120}
                                                        placeholder="State"
                                                        value={state}
                                                        onChange={(e) => setState(e.target.value)}
                                                    />
                                                </div>
                                                <div className="rounded border p-1 m-1">
                                                    <label className="text-h2 bold">Country</label>
                                                    <input
                                                        className="text-h2 border-none"
                                                        maxLength={120}
                                                        placeholder="Country"
                                                        value={country}
                                                        onChange={(e) => setCountry(e.target.value)}
                                                    />
                                                </div>
                                            </>
                                        )}
                                        {!showMore && (
                                            <>
                                                <div className="center cursor" onClick={() => setShowMore(true)}>
                                                    More
                                                </div>
                                                <br />
                                            </>
                                        )}

                                        <div className="button-ui fill" onClick={postTrades}>
                                            <MdAdd className="icon" /> Create
                                        </div>
                                    </div>
                                </div>

                                <br />

                            </div>

                        )}


                        {/* categoryData */}

                        <div className="post_div">
                            {categoryData[0]?.category}
                            <div className="flex items-center">

                                {isLoading2 ? (
                                    <Lodinging />
                                ) : categoryData.length === 0 ? (
                                    <div className="button-ui rounded m-1 p-2" onClick={() => {
                                        setAddcontact(!addcontact);
                                        setShowMore(false);

                                    }}>
                                        {addcontact ? <MdClose className="icon" /> : <MdAdd className="icon" />}
                                    </div>
                                ) : (
                                    <div className="ui-griddiv">
                                        <div className="flex">
                                        <div style={{ width: '48px' }} className="ui-items button-ui rounded p-2 bold " onClick={() => setAddcontact(!addcontact)}>
                                            {addcontact ? <MdClose className="icon" /> : <MdAdd className="icon" />}
                                        </div>


                                        {categoryData.map((category, index) => (
                                            <div className="ui-items" key={index}>
                                                <div
                                                    className={`button-ui2 rounded fcap p-2 bold sline ${selectcategory === category ? "blue-back" : ""}`}
                                                    onClick={() => {
                                                        setSelectcategory(category);
                                                        fetch_by_CategoryData(category);
                                                    }}
                                                >
                                                    {category}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    </div>
                                )}


                            </div>
                            <br />
                            <div className="rounded items-back">
                                <table>
                                    <tr>
                                        <td width={30}><MdSearch className="icon" /></td>
                                        <td>
                                            <input
                                                value={searchTerm}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                className="border-none items-back"
                                                placeholder={`${phonebookData.length} ${selectcategory} Contacts`}
                                            />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <br />
                            {isLoading ? (
                                <Lodinging />
                            ) : phonebookData.length === 0 ? (
                                <div className="text-h1 text-off center p-1">
                                    No phonebook data found.<br />
                                    Create a free phonebook and enjoy managing your personal contacts!
                                </div>
                            ) : (
                                <div className="ui-grid">
                                    {phonebookData.map((row) => (
                                        <div className="ui-items items-back border" key={row.uid}>
                                            <table>
                                                <tbody>


                                                    <tr>

                                                        <td >
                                                            <table>
                                                                <tr>
                                                                    <td onClick={() => navigate("/" + row.uid)}>
                                                                        <table>
                                                                            <tr>
                                                                                <td className="text-h2 bold">{row?.child?.name}</td>

                                                                            </tr>
                                                                            <tr>
                                                                                <td>      <a className="text-h2 "  >
                                                                                    {row?.child?.countrycode || ""}{row?.child?.mobilenumber || ""}
                                                                                </a></td>
                                                                            </tr>
                                                                        </table>


                                                                    </td>

                                                                    <td width={25}>
                                                                        <a className="text-h2 bold" href={`tel:${row?.child?.countrycode || ""}${row?.child?.mobilenumber || ""}`}>
                                                                            <MdCall className="icon cursor" /></a>
                                                                    </td>
                                                                </tr>
                                                            </table>

                                                        </td>
                                                    </tr>

                                                    {/* <tr>
                                                        <td colSpan={2}>
                                                            <button
                                                                className="text-h3 text-off cursor"
                                                                onClick={() => toggleMoreInfo(row.uid)}
                                                            >
                                                                {expandedRows[row.uid] ? "Hide More Info" : "Show More Info"}
                                                            </button>
                                                        </td>
                                                    </tr> */}
                                                </tbody>
                                            </table>
                                            {/* {expandedRows[row.uid] && (
                                                
                                                    <table className="more-info-table expanded">
                                                        <tbody>
                                                            {row?.child?.phonenumber && (
                                                                <tr>
                                                                    <td className="text-off">Phone</td>
                                                                    <td>

                                                                        <table></table>
                                                                        <table>
                                                                            <tr>
                                                                                <td>  <a className="text-h2 bold" href={`tel:${row?.child?.countrycode || ""}${row?.child?.phonenumber || ""}`}>
                                                                                    {row?.child?.countrycode || ""}{row?.child?.phonenumber || ""}
                                                                                </a>
                                                                                </td>

                                                                                <td width={25}>
                                                                                    <a className="text-h2 bold" href={`tel:${row?.child?.countrycode || ""}${row?.child?.phonenumber || ""}`}>
                                                                                        <MdCall className="icon cursor" /></a>
                                                                                </td>
                                                                            </tr>
                                                                        </table>

                                                                    </td>
                                                                    
                                                                </tr>
                                                            )}
                                                            <tr>
                                                                <td className="text-off">Created</td>
                                                                <td>
                                                                    {row.date_time?.toDate
                                                                        ? `${row.date_time.toDate().toLocaleDateString()} ${row.date_time.toDate().toLocaleTimeString()}`
                                                                        : "No data"}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                
                                            )} */}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Footers />
            <Navbar />
        </div>
    );
}
